export const environment = {
  production: true,
  preproduction: false,
  apiUrl: 'https://api.kech.cab',
  apiKey:"43jdhkddkwefgwuefvokwenftgewefw",
  walletBladiUrl:"https://wallet.wetaxi.ma",
  apiKeyGoogleMap:"AIzaSyBcXJQdOxYFWI3jP23OSHUGuI8hktRVKjY",
  commerceUrl: "https://mpay.casky.io",
  reviewFrontUrl: 'https://review.kech.cab',
  socketUrl: 'api.kech.cab',
  secure: true,
  port: 443,
  ctmPass:"wallet_trip",
  tokenIfram:"wq1k85fa630fj232ofeyfftgga",
  chatBotUrl:"https://sandbox.prod.gomorocco.travel" ,
  seoApiUrl:"http://localhost:3000",
  tripassUrl:"https://tripass.ma"
 

};

